import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import styled from 'styled-components';
const StyledUIFileAttachment = styled(UIFileAttachment).withConfig({
  displayName: "StyledUIFileAttachment",
  componentId: "j334xe-0"
})(["background-color:transparent;border:none;padding:8px 12px;"]);
export default StyledUIFileAttachment;